var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4561 5.85833C17.7758 5.02816 18.9504 5.02816 19.2702 5.85833C19.9957 7.74207 22.3471 8.3646 23.9134 7.10017C24.6099 6.53785 25.6218 7.1329 25.4844 8.00102C25.1687 9.99519 26.8947 11.7106 28.8829 11.3972C29.7663 11.258 30.3436 12.2782 29.7915 12.9591C28.5213 14.5255 29.1511 16.8752 31.0337 17.5972C31.8613 17.9145 31.8613 19.0859 31.0337 19.4032C29.1511 20.1252 28.5213 22.4748 29.7915 24.0413C30.3436 24.7221 29.7663 25.7424 28.8829 25.6032C26.8947 25.2898 25.1687 27.0052 25.4844 28.9994C25.6218 29.8675 24.6099 30.4625 23.9134 29.9002C22.3471 28.6358 19.9957 29.2583 19.2702 31.1421C18.9504 31.9722 17.7758 31.9722 17.4561 31.1421C16.7305 29.2583 14.3791 28.6358 12.8128 29.9002C12.1163 30.4625 11.1044 29.8675 11.2418 28.9994C11.5575 27.0052 9.83154 25.2898 7.84329 25.6032C6.95993 25.7424 6.38258 24.7221 6.93471 24.0413C8.20491 22.4748 7.57508 20.1252 5.69255 19.4032C4.86493 19.0859 4.86493 17.9145 5.69255 17.5972C7.57508 16.8752 8.2049 14.5255 6.93471 12.9591C6.38258 12.2782 6.95993 11.258 7.84329 11.3972C9.83154 11.7106 11.5575 9.99519 11.2418 8.00102C11.1044 7.1329 12.1163 6.53785 12.8128 7.10017C14.3791 8.36461 16.7305 7.74207 17.4561 5.85833Z",
    stroke: "#5956E9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4533 18.5001C26.4533 22.9554 22.833 26.5709 18.3624 26.5709C13.8918 26.5709 10.2715 22.9554 10.2715 18.5001C10.2715 14.0448 13.8918 10.4293 18.3624 10.4293C22.833 10.4293 26.4533 14.0448 26.4533 18.5001Z",
    stroke: "#5956E9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.594309155d68654a9288403f7a7917bd.svg";
export { ForwardRef as ReactComponent };